import ChronusApi from './../services/ChronusApi';
import { getValueByKeyPath } from './../utils/GeneralUtils';

export const apiCallTypes = {
  GET: 'get',
  POST: 'post'
}

const getErrorMessage = (error) => {
  return getValueByKeyPath(error, "response.data.message", null) || jsCommonTranslations.commonErrorMessage
}

const fetchDataCall = (data, url, resolve, reject) => {
  ChronusApi.getUrlJSON(url, data).then((response) => {
    resolve(response)
  }, (error) =>{
    reject(getErrorMessage(error))
  });
}

const callApiFunction = (url, data, type) => {
  switch(type){
    case apiCallTypes.GET:
      return ChronusApi.getUrlJSON(url, data);
    case apiCallTypes.POST:
      return ChronusApi.postUrlJSON(url, data);
  }
}

const callActionCable = (initData) => {
  return new Promise((resolve, reject) => {
    JobStatus.initializeAsync(initData, resolve, reject)
  })
}

const callJobExecutor= (initialParams, responseData, resolve, reject) => {
  if(getValueByKeyPath(responseData , "cable_polling_data.context_id", null)){
    callActionCable(responseData).then((completionOptions) => {
      fetchDataCall({...initialParams, ...completionOptions.data}, completionOptions.redirect_path, resolve, reject);
    }, (error) => {
      reject(getErrorMessage(error))
    })
  }
  else{
    resolve(responseData)
  }
}

const handleSavingContextId = (saveJobExecutorContextId, responseData) => {
  if(saveJobExecutorContextId){
    saveJobExecutorContextId(responseData.cable_polling_data.context_id);
  }
}

export const stopJobExecutor = (contextId) => {
  JobStatus.handlePostCompletePollingForContextId(contextId);
}

export const useJobExecutor = (url, type = apiCallTypes.GET) => {
  return (data = {}) => {
    return new Promise((resolve, reject) => {
      callApiFunction(url, data, type).then((response) => {
        let responseData = type == apiCallTypes.GET ? response : response.data
        handleSavingContextId(data.saveJobExecutorContextId, responseData);
        callJobExecutor(data, responseData, resolve, reject)
      }, (error) => {
        reject(getErrorMessage(error))
      })
    });
  }
}

export default useJobExecutor;
